/**
 * LOS NÚMEROS DE "CHAT" Y "AVISOS" DEL CLIENTE, AL DÍA (12-10, pestaña Devolución del
 * cuaderno).
 *
 * Solo se pedían al cambiar de pantalla: quien estaba quieto no veía llegar la respuesta,
 * y después de leerla el "1" seguía en el menú hasta que navegaba. Ahora se vuelven a pedir:
 *
 *   - cuando la pantalla del chat avisa de que ha marcado mensajes como leídos;
 *   - cada minuto, que es lo que ya hace el panel del equipo con los suyos, y solo con la
 *     pestaña a la vista: una pestaña en segundo plano no pregunta nada;
 *   - al volver a la pestaña.
 *
 * Va en un fichero aparte para que el chat avise sin conocer el menú, igual que
 * `finDelRecorrido.js`.
 */

export const EVENTO_CONTADORES = 'contadores-del-cliente-cambian';

/** Cada cuánto se vuelven a pedir con la pestaña a la vista. */
export const CADA_CUANTO_MS = 60000;

//: Lo lanza quien acaba de cambiar lo que cuentan (el chat, al marcar como leído).
export const avisarDeContadores = () => {
    try {
        window.dispatchEvent(new Event(EVENTO_CONTADORES));
    } catch (e) {
        console.error('No se pudo avisar del cambio en los contadores', e);
    }
};

const aLaVista = () => typeof document === 'undefined' || document.visibilityState !== 'hidden';

/**
 * Llama a `pedir` cuando toca volver a pedir los números. Devuelve la función para dejar de
 * vigilar (para el `return` de un efecto). No hace la primera petición: esa es de quien llama.
 */
export const vigilarContadores = (pedir, cadaMs = CADA_CUANTO_MS) => {
    const siSeVe = () => { if (aLaVista()) pedir(); };
    window.addEventListener(EVENTO_CONTADORES, pedir);
    document.addEventListener('visibilitychange', siSeVe);
    const reloj = setInterval(siSeVe, cadaMs);
    return () => {
        window.removeEventListener(EVENTO_CONTADORES, pedir);
        document.removeEventListener('visibilitychange', siSeVe);
        clearInterval(reloj);
    };
};
